import AnimatedCursor from "react-animated-cursor"
import { useEffect, useState } from "react"

// For non-App.tsx pages
export default function Cursor() {
	const [mobile, setMobile] = useState(false)

	// Detect device type
	useEffect(() => {
		const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
		if (isMobile) {
			setMobile(true)
		} else {
			setMobile(false)
		}
	}, [])

	return (
		<>
			{/* Display custom cursor on desktop */}
			{!mobile ? (
				<div>
					<AnimatedCursor
						innerSize={0}
						outerSize={18}
						// color="193, 11, 111"
						outerAlpha={1}
						showSystemCursor={true}
						outerStyle={{
							// filter: "invert(1)",
							mixBlendMode: "difference",
							// border: "2px solid",
							background: "#FFFFFF",
							display: window.innerWidth <= 768 ? "none" : "block", // Hide cursor on devices with width <= 768px
							// borderColor: "#FFFFFF",
							// opacity: 50
						}}
						innerScale={0}
						outerScale={4}
						// outerScale={2}
						trailingSpeed={7}
						clickables={[
							"a",
							'input[type="text"]',
							'input[type="file"]',
							'input[type="email"]',
							'input[type="number"]',
							'input[type="submit"]',
							'input[type="image"]',
							"label[for]",
							"select",
							"textarea",
							"button",
							".link",
						]}
					/>
				</div>
			) : (
				""
			)}
		</>
	)
}
